"use strict";
/// <reference path="Clipboard.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clipboard = exports.CutMethod = exports.PasteMethod = exports.CopyMethod = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
const $ = require("jquery");
const LocalStorageManager_1 = require("../../javascript/LocalStorageManager");
const Utilities_1 = require("../../javascript/Utilities");
const SelectionContext_1 = require("../Menu/SelectionContext");
const CommandLayout_1 = require("../Menu/CommandLayout");
const Instance_1 = require("../../model/Instance");
let _ = require("underscore");
exports.CopyMethod = {
    cssClass: "",
    cssClassArray: [],
    description: "",
    fulllicense: false,
    icon: "94344",
    imageUrl: "WSProxy.axd?synws=Icon/icon/docid=94344/64",
    index: 2,
    menuEntry: "cefunc.159",
    method: "cefunc.159",
    selCount: -2,
    showText: true,
    style: 32768,
    text: "Kopieren",
};
exports.PasteMethod = {
    cssClass: "",
    cssClassArray: [],
    description: "",
    fulllicense: true,
    icon: "94333",
    imageUrl: "WSProxy.axd?synws=Icon/icon/docid=94333/32",
    menuEntry: "cefunc.161",
    method: "cefunc.161",
    selCount: -1,
    showText: false,
    style: 58851456,
    text: "Einfügen",
};
exports.CutMethod = {
    cssClass: "noIcon",
    cssClassArray: ["noIcon"],
    description: "",
    fulllicense: true,
    menuEntry: "cefunc.160",
    method: "cefunc.160",
    selCount: -2,
    showText: false,
    style: 33686528,
    text: "cefunc.160",
};
class Clipboard {
    static init($elem, options) {
        return $elem.each(function () {
            let synData = $elem.data('synClipboard');
            if (!synData) { // the plugin hasn't been initialized yet
                $elem.trigger("beginInit");
                $elem.data('synClipboard', $.extend({
                    context: undefined,
                    iconWsUrl: Utilities_1.synUtil.getWSUrl("Icon"),
                    iconSize: 16,
                    maxitems: 20
                }, options));
                synData = $elem.data('synClipboard');
                synData.clipboardItems = [];
                synData.allowCloseDropdown = true;
                synData.doCloseDropdown = undefined;
                let clipboardContainer = $elem;
                clipboardContainer.addClass("synClipboard dropdown");
                if (Utilities_1.synUtil.isHDScreen) {
                    $elem.addClass('HDScreen');
                    synData.iconSize = 32;
                }
                let button = $('<button type="button" class="btn dropdown-toggle" data-toggle="dropdown" title="' + Utilities_1.synUtil.Strings.getValue("menuclipboard") + '"><i class="fa fa-clipboard"></i><span class="badge"></span></button>');
                clipboardContainer.append(button);
                let clipboardItems = $('<div class="clipboard_items dropdown-menu pull-right" id="clipboard_items"></div>');
                clipboardContainer.append(clipboardItems);
                button.dropdown();
                let pasteLink = $('<a class="pull-left alle link">' + Utilities_1.synUtil.Strings.getValue("insertall") + '</a>');
                let delLink = $('<a class="clipboard_empty pull-right alle link">' + Utilities_1.synUtil.Strings.getValue("deleteall") + '</a>');
                clipboardItems.prepend(pasteLink);
                clipboardItems.prepend(delLink);
                pasteLink.on("click", function (e) {
                    $elem.trigger("needContext");
                    if (Clipboard.isAllowed($elem, exports.PasteMethod))
                        Clipboard.paste($elem);
                    else
                        Utilities_1.synUtil.Notifications.error("Einfügen nicht erlaubt");
                });
                delLink.on("click", function (e) {
                    Clipboard.empty($elem);
                });
                clipboardContainer.on('hide.bs.dropdown', function () {
                    return synData.allowCloseDropdown;
                });
                clipboardContainer.on('hidden.bs.dropdown', function () {
                    $elem.find('button.btn').removeClass('btn-primary');
                });
                clipboardContainer.on('show.bs.dropdown', function () {
                    $elem.find('button.btn').addClass('btn-primary');
                });
                Clipboard.load($elem);
                Clipboard.render($elem);
                $elem.trigger("initSuccess");
                $elem.trigger("endInit");
            }
        });
    }
    static copy($elem, ids) {
        const synData = $elem.data('synClipboard');
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("InstanceMultiple"),
            requestData: { ids: ids.join(";"), properties: "id;name;icon" },
            done(data) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    for (let prop in data) {
                        let instance = yield Instance_1.Instance.fromJSON(data[prop]);
                        let clipboardObject = {
                            id: instance.id.valueToString(),
                            name: instance.name.valueToString(),
                            imageUrl: synData.iconWsUrl + instance.icon.value + '/' + synData.iconSize
                        };
                        Clipboard.addToClipboard($elem, clipboardObject);
                    }
                    Clipboard.render($elem);
                    Clipboard.save($elem);
                });
            }
        });
    }
    static paste($elem, id, parentId, relId) {
        const synData = $elem.data('synClipboard');
        if (parentId == undefined && relId == undefined) {
            parentId = synData.context.parentControl ? synData.context.parentControlParentContext.parentId : synData.context.normalParentContext.parentId;
            relId = synData.context.parentControl ? synData.context.parentControlParentContext.parentRelId : synData.context.normalParentContext.parentRelId;
        }
        let wsUrl = Utilities_1.synUtil.getWSUrl("InstanceAddChildren") + parentId + "/" + (typeof relId === "undefined" ? SelectionContext_1.SpecialRelIds.Undefined : relId);
        let ids = [];
        if (!id) { /* Paste All */
            _.each(synData.clipboardItems, function (item) {
                ids.push(item.id);
            });
        }
        else /* Paste One */
            ids.push(id[0]);
        Utilities_1.synUtil.getAJAXData({
            method: "PUT",
            url: wsUrl,
            requestData: JSON.stringify({ instances: ids }),
            done(data) {
                if (!id) /* Paste All */
                    Clipboard.empty($elem);
                else { /* Paste One */
                    Clipboard.removeItem($elem, id[0]);
                    Clipboard.save($elem);
                }
                Clipboard.render($elem);
                $elem.trigger("afterPaste", ids);
            }
        });
    }
    // Returns the ids and removes them from clipboard
    static pasteForChecklist($elem, id) {
        const synData = $elem.data('synClipboard');
        let ids = [];
        if (!id) { /* Paste All */
            _.each(synData.clipboardItems, function (item) {
                ids.push(item.id);
            });
        }
        else /* Paste One */
            ids.push(id);
        if (!id) /* Paste All */
            Clipboard.empty($elem);
        else { /* Paste One */
            Clipboard.removeItem($elem, id);
            Clipboard.save($elem);
        }
        Clipboard.render($elem);
        $elem.trigger("afterPaste", ids);
        return ids;
    }
    static itemCount($elem) {
        const synData = $elem.data('synClipboard');
        return _.size(synData.clipboardItems);
    }
    static items($elem) {
        const synData = $elem.data('synClipboard');
        return synData.clipboardItems;
    }
    static empty($elem) {
        return $elem.each(function () {
            const synData = $elem.data('synClipboard');
            synData.clipboardItems = [];
            Clipboard.save($elem);
            Clipboard.render($elem);
        });
    }
    static refresh($elem) {
        return $elem.each(function () {
            Clipboard.load($elem);
            Clipboard.render($elem);
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            $(this).off("beginInit");
            $(this).off("initSuccess");
            $(this).off("endInit");
            $(this).off("afterPaste");
            $(this).off("afterCopy");
            $(this).off("afterSave");
            $(this).off("needContext");
            $elem.removeData('synClipboard');
        });
    }
    static remove($elem, id) {
        Clipboard.removeItem($elem, id);
        Clipboard.save($elem);
    }
    static addToClipboard($elem, clipboardObject) {
        const synData = $elem.data('synClipboard');
        let matchItem = _.findWhere(synData.clipboardItems, { id: clipboardObject.id });
        if (!matchItem) {
            synData.clipboardItems.push({
                id: clipboardObject.id,
                name: kendo.htmlEncode(clipboardObject.name),
                imageUrl: kendo.htmlEncode(clipboardObject.imageUrl)
            });
            $elem.trigger("afterCopy", [clipboardObject.name]);
        }
    }
    static keepDropdownOpen($elem) {
        const synData = $elem.data('synClipboard');
        clearTimeout(synData.doCloseDropdown);
        synData.allowCloseDropdown = false;
        synData.doCloseDropdown = window.setTimeout(function () { synData.allowCloseDropdown = true; }, 300);
    }
    static save($elem) {
        const synData = $elem.data('synClipboard');
        LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Clipboard, "clipboardItems", JSON.stringify(synData.clipboardItems));
        $elem.trigger("afterSave", _.size(synData.clipboardItems));
    }
    static load($elem) {
        const synData = $elem.data('synClipboard');
        let items = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Clipboard, "clipboardItems");
        if (!items)
            return;
        synData.clipboardItems = JSON.parse(items);
        $elem.trigger("afterLoad", _.size(synData.clipboardItems));
    }
    static removeItem($elem, id) {
        const synData = $elem.data('synClipboard');
        synData.clipboardItems = _.without(synData.clipboardItems, _.findWhere(synData.clipboardItems, { id }));
        if (synData.clipboardItems.length !== 0)
            Clipboard.keepDropdownOpen($elem);
    }
    static render($elem) {
        const synData = $elem.data('synClipboard');
        let clipboardItems = $elem.find('#clipboard_items');
        let linkText;
        clipboardItems.find('table').remove();
        let tableContainer = $('<table><tbody></tbody></table>');
        let tableRow;
        let shownItems = _.first(synData.clipboardItems, synData.maxitems);
        _.each(shownItems, function (item) {
            linkText = kendo.htmlEncode(item.name);
            if ((linkText === null || linkText === void 0 ? void 0 : linkText.length) > 35) {
                linkText = linkText.substring(0, 35) + " ...";
            }
            tableRow = String()
                + '<tr class="itemRow" data-id="' + item.id + '">'
                + '<td><a class="clipboard_paste link"><i class="fa fa-sign-in fa-flip-horizontal"></i></a></td>'
                + '<td><img src="' + item.imageUrl + '"> ' + linkText + '</td>'
                + '<td><a class="clipboard_remove link"><i class="fa fa-times"></i></a></td>'
                + '</tr>';
            $(tableRow).appendTo(tableContainer);
        });
        if (_.size(synData.clipboardItems) > synData.maxitems) {
            tableRow = String()
                + '<tr class="itemRow">'
                + '<td colspan="3" style="text-align:right;padding-top:5px;">' + synData.maxitems + ' ' + kendo.format(Utilities_1.synUtil.Strings.getValue("listof"), _.size(synData.clipboardItems)) + '</td>'
                + '</tr>';
            $(tableRow).appendTo(tableContainer);
        }
        if (_.size(synData.clipboardItems) > 0) {
            $elem.find('.badge').text(_.size(synData.clipboardItems)).show();
            $elem.find('button.btn').show();
        }
        else {
            $elem.find('.badge').text('0').hide();
            $elem.find('button.btn').hide();
            $elem.removeClass('open');
        }
        if ($elem.hasClass('open'))
            $elem.find('button.btn').addClass('btn-primary');
        else
            $elem.find('button.btn').removeClass('btn-primary');
        tableContainer.appendTo(clipboardItems);
        clipboardItems.find('.clipboard_paste').on('click', function (e) {
            let id = $(this).closest('tr').attr('data-id');
            let matchItem = _.findWhere(synData.clipboardItems, { id });
            if (matchItem) {
                $elem.trigger("needContext");
                if (Clipboard.isAllowed($elem, exports.PasteMethod))
                    Clipboard.paste($elem, [id]);
                else
                    Utilities_1.synUtil.Notifications.error("Einfügen nicht erlaubt");
            }
        });
        clipboardItems.find('.clipboard_remove').on('click', function (e) {
            let id = $(this).closest('tr').attr('data-id');
            let matchItem = _.findWhere(synData.clipboardItems, { id });
            if (matchItem) {
                Clipboard.removeItem($elem, id);
                Clipboard.save($elem);
                Clipboard.render($elem);
            }
        });
    }
    static isAllowed($elem, method) {
        const synData = $elem.data('synClipboard');
        return CommandLayout_1.CommandLayoutsType.IsMethodAllowed(method, synData.context);
    }
}
exports.Clipboard = Clipboard;
// Dispatcher code
(($) => {
    $.fn.synClipboard = function (method) {
        if (Clipboard[method])
            return Clipboard[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Clipboard.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synClipboard");
    };
})(jQuery);
